import { render, staticRenderFns } from "./BillarReport.vue?vue&type=template&id=6ac61dfd"
import script from "./BillarReport.vue?vue&type=script&lang=js"
export * from "./BillarReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports